import { ISelectOption, Select } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { IExternalAttributeVm, IValidationResult } from '../../../models';
import { ClearDiv, LabelAbove, Section } from '../../common';

export interface IMappedAttributeSectionProps {
	attributes: IExternalAttributeVm[];
	selectedAttributes: string[];
	selected?: string;
	validationResult?: IValidationResult;
	onSelect: (externalAttributeColumnName: string, attribute?: IExternalAttributeVm) => void;
}

export interface IMappedAttributeSectionState {
	selected?: string;
	selectedAttributes: string[];
}

export class MappedAttributeSection extends React.Component<IMappedAttributeSectionProps, IMappedAttributeSectionState> {
	constructor(props: IMappedAttributeSectionProps) {
		super(props);

		this.state = { selected: undefined, selectedAttributes: [] };

		this.onSelect = this.onSelect.bind(this);
	}

	/*
		Note: because this component is used inside a modal we cannot rely on it receiving updates from the props
			  an internal function sets the state when a new selection is made
	*/
	public componentDidMount() {
		this.setState({
			selectedAttributes: [...this.props.selectedAttributes],
			selected: this.props.selected,
		});
	}

	public render() {
		const { validationResult } = this.props;
		const { selected } = this.state;
		const attributes = this.getAttributesForSelector();

		const showError = (validationResult && !validationResult.isValid) || false;
		const messages = !validationResult ? '' : validationResult.errors || [];

		return (
			<Section id='custom-question-mapped-attribute' sectionHeader={ContentConstants.CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_HEADER}>
				<LabelAbove type='clickbox' textIsHtml={true} text={ContentConstants.CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_MESSAGE} />
				<Select
					items={attributes}
					size='md'
					selectSize='lg'
					onApply={this.onSelect}
					displayText={ContentConstants.MAPPED_ATTRIBUTE_SELECTOR_TEXT}
					disabled={attributes.length === 0}
					selectedValue={selected}
					error={showError}
					message={messages}
					showApplyButton={false}
				/>
				<ClearDiv clearHeight={'50px'} />
			</Section>
		);
	}

	public getAttributesForSelector(): ISelectOption[] {
		const { attributes } = this.props;
		const { selectedAttributes } = this.state;

		return attributes.map((attr: IExternalAttributeVm, index: any) => ({
			name: attr.columnName,
			displayText: attr.displayName,
			displayOrder: index,
			disabled: selectedAttributes.indexOf(attr.columnName) > -1,
		}));
	}

	public onSelect(value?: any) {
		if (value !== undefined) {
			const attribute: IExternalAttributeVm = this.props.attributes.find((attr: IExternalAttributeVm) => attr.columnName === value) || {
				columnName: value,
				attributeName: undefined,
				displayName: '',
			};
			this.props.onSelect(value, attribute);

			this.updateSelectedAttributes(this.state.selected, value);
		}
	}

	private updateSelectedAttributes(original?: string, next?: string) {
		if (next !== undefined) {
			const selectedAttributes = this.state.selectedAttributes.filter((attr: string) => attr !== original).concat([next]);
			this.setState({
				selectedAttributes,
				selected: next,
			});
		}
	}
}
